<!--
 * @Author: chenyn 1826650603@qq.com
 * @Date: 2023-09-25 11:43:15
 * @LastEditors: chenyn 1826650603@qq.com
 * @LastEditTime: 2023-11-09 10:40:49
 * @FilePath: \smart-campus-platform-front-vue\src\views\homepage\map\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div @click="showHidden = false">

    <div class="map-con maxW">
      <div class="conten">
        <div class="Level " :class="'Level_' + (index + 1)" v-for="(item, index) in allLevel" :key="index">

          <img class="number" @click="goDetail(item, index + 1)"
            :src="require('../../../assets/images/map/' + (index + 1) + '_' + item.key + '.png')" />

          <img @click="goDetail(item, index + 1)" :src="require('../../../assets/images/map/but_' + item.key + '.png')" />
          <div class="status_icon" v-if="item.status === 1">
            <img src="../../../assets/images/map/finish_iocn.png" />
          </div>

          <div class="status_icon" v-if="!item.status">
            <div>
              <span>{{ item.complete_task_count }}/{{ item.total_task_count }}</span>
              <Progress style="margin-top: 40rpx;" :explain="null"
                :percentage="getLevePercentage(item.complete_task_count, item.total_task_count)"
                percentBackground="#007aff">
              </Progress>
            </div>
          </div>
        </div>
      </div>

      <div class="foot">
        <div class="map_select">
          <img src="../../../assets/images/map/map_select.png" v-if="dataList.length > 1"
            @click.stop="showHidden = !showHidden" />
        </div>
        <div class="start_but" @click="goStart()" v-if="dataList.length">
          <img src="../../../assets/images/map/start_button.png" />

        </div>
      </div>
      <div class="combox">
        <Combox :list="dataList" @checkItem="checkItem($event, true)" :currentCheckItem="checkItemId" v-if="showHidden">
        </Combox>
      </div>
    </div>
    <div class="dependent maxW" v-if="placeholder">
      <i class="ipng image_state01"></i>
      <p>- {{ $t('global.noData') }} -</p>
    </div>
  </div>
</template>

<script>
import Progress from './components/progress.vue'
import Combox from './components/combox.vue'
export default {
  components: {
    Progress,
    Combox
  },
  data() {
    return {
      placeholder: false,
      showHidden: false,
      checkItemId: null,
      dataList: [],
      params: {
        keyword: null,
        page_index: 1,
        page_size: 9999,
        user_id: this.$g.user_id,
        is_limit: 1  // 固定传 1 权限过滤
      },
      allLevel: [
        // {
        //   status: 0,
        //   text: '已完成',
        //   key: 'finish',
        //   topKey: 'finish',
        //   complete_task_count: 10,
        //   total_task_count: 20
        // },
        // {
        //   status: 1,
        //   text: '进行中',
        //   key: 'selected',
        //   topKey: 'selected',
        //   complete_task_count: 10,
        //   total_task_count: 20

        // },
        // {
        //   status: 2,
        //   text: '未解锁',
        //   key: 'default',
        //   topKey: 'default',
        //   complete_task_count: 10,
        //   total_task_count: 20
        // }
      ],
      topLevelStatus: [
        {
          status: 0,
          text: '进行中',
          key: 'selected',
          topKey: 'default'
        },
        {
          status: 1,
          text: '已完成',
          key: 'finish',
          topKey: 'default'
        },
        {
          status: 2,
          text: '未解锁',
          key: 'default',
          topKey: 'default'
        }
      ],
      detail: null,
      select_map: null
    };
  },

  created() {
    this.getMapList()
  },
  methods: {
    getLevePercentage(val, all) {
      return (val / all) * 100
    },
    goStart() {
      let ing
      let level
      this.allLevel.forEach((r, index) => {
        if (r.map_little_see_status === 1) {
          level = index + 1
          ing = r
        }
      })
      if (ing) {
        this.$router.push({ path: '/home/mapLevel', query: { id: this.checkItemId, level: level } });
      } else {
        this.$message.closeAll()
        this.$message.success(this.$t('global.allTestComp'))
        // const target =  this.allLevel.find((item, i) => i === 0)
        // target && this.goDetail(target, 1)
      }

    },
    goDetail(item, level) {
      if (item && item.map_little_see_status === 3) {
        this.$message.warning('未解锁')
      }
      if (!item || item.map_little_see_status !== 3) {
        this.$router.push({ path: '/home/mapLevel', query: { id: this.checkItemId, level: level } });
      }
    },
    getMapList() {

      let success = res => {
        this.dataList = res.data.data
        if (!this.dataList.length) {
          this.topLevelStatus = []
          this.allLevel = []
        }
        let checkId = Number(sessionStorage.getItem('mapCheckId'))
        if (this.dataList.length && checkId) {
          this.checkItem(checkId, false)
        }
        if (this.dataList.length && !checkId) {
          this.checkItem(this.dataList[0].id, false)
        }
      }

      this.$ajax.get('/api/map/map_list', {
        params: this.params,
        func: {
          success
        }
      })
    },
    checkItem(e, isClick) {

      if (isClick) {
        sessionStorage.setItem("mapCheckId", e);
      }
      this.checkItemId = e
      this.detail = this.dataList.filter(r => r.id === e)[0]
      const topArr = []
      if (this.detail) {
        this.detail.map_little.forEach(obj1 => {
          const find = topArr.find(r => r.complete_task_status === 0)
          if (find) {
            topArr.push({ ...obj1, ...this.topLevelStatus[2] })
          } else {
            const matchingObj = this.topLevelStatus.find(obj2 => obj2.status === obj1.complete_task_status);
            if (matchingObj) {
              topArr.push({ ...obj1, ...matchingObj });
            }
          }
        })
        this.allLevel = topArr
      }

    }
  },
};
</script>
<style lang="scss">
.map-con {
  margin: auto;
  margin-top: 9%;
  margin-bottom: 4rem;
  width: 100%;
  height: 850px;
  background: url('../../../assets/images/map/map_bg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;

  .conten {
    .Level {
      position: absolute;
      width: 210px;
      height: 193px;
      cursor: pointer;

      .number {
        position: absolute;
        bottom: 100px;
        z-index: 999;
        height: 65rpx;
        width: 65rpx;
      }

      >img {
        // position: absolute;
        // bottom: 0;
        // left: 50% !important;
        transform: translateX(-50%);
        // width: 65rpx !important;
        // height: 65rpx !important;
        // bottom: 50px !important;
        // z-index: 99;
      }

      // >image:nth-child(2) {
      //   width: 100%;
      //   height: 60%;
      // }

      .status_icon {
        position: absolute;
        right: 50%;
        transform: translateX(-50%);
        top: -50%;

        >div:nth-child(1) {
          position: absolute;
          right: 50%;
          top: 50px;
          transform: translateX(-20%);
          width: 150px;
          color: #fff;
          font-size: 22px;


          span {
            position: absolute;
            left: 50%;
            bottom: 40px;
            transform: translateX(-50%);
          }
        }

        >image {
          width: 100px;
          height: 110px;
          z-index: 999;
        }
      }
    }

    .Level_1 {
      left: 31%;
      bottom: 8%;
    }

    .Level_2 {
      right: 22%;
      bottom: 29.5%;
    }

    .Level_3 {
      left: 32%;
      bottom: 50%;
    }
  }

  .combox {
    width: 100%;
    position: absolute;
    bottom: 360px;
    left: -76%;
    z-index: 9999;
  }

  .foot {
    width: 90%;
    position: absolute;
    bottom: 30px;
    left: 30px;
    display: flex;
    justify-content: space-between;

    .map_select {
      height: 120px;
      width: 120px;
      cursor: pointer;
      >img {
        width: 100%;
        height: 100%;
      }
    }

    .start_but {
      height: 120px;
      width: 300px;
      cursor: pointer;
      >img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
